import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import BenchmarkForm from 'components/organisms/forms/BenchmarkForm'

import { crudActionsMap } from 'utils/helpers'

const BenchmarkCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.benchmarks')} / ${t('common.' + action)}`} />
      <PageBody>
        <BenchmarkForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default BenchmarkCrudPage
